import { ref, type Ref } from 'vue';

export interface ToastOptions {
  title: string;
  message: string;
  duration?: number;
  type?: 'success' | 'error' | 'info';
  /** Show fixed in the center of the viewport (copy, rebet errors, etc.). */
  centered?: boolean;
}

export type ToastState = ToastOptions & {
  duration: number;
  type: 'success' | 'error' | 'info';
};

const toast: Ref<ToastState | null> = ref(null);
let hideTimer: ReturnType<typeof setTimeout> | null = null;

export function useToast() {
  const showToast = (options: ToastOptions) => {
    const duration = options.duration ?? 5000;
    const type = options.type ?? 'info';

    if (hideTimer) {
      clearTimeout(hideTimer);
      hideTimer = null;
    }

    toast.value = {
      title: options.title,
      message: options.message,
      duration,
      type,
      centered: options.centered,
    };

    hideTimer = setTimeout(() => {
      toast.value = null;
      hideTimer = null;
    }, duration);
  };

  return {
    toast,
    showToast,
  };
}
